// extracted by mini-css-extract-plugin
export default {"headerStyle":"CartHeader_headerStyle__6wVRp"};